export function err(msg: string): never {
  throw new Error(msg)
}
